import React, { useState } from "react";
import {
  FileInput,
  FileField,
  SimpleForm,
  useRefresh,
  useNotify,
  fetchStart,
  fetchEnd,
} from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { useForm } from "react-final-form";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import axios from "axios";
import { apiUrl } from "../../../dataProvider";
import { rawFileExtraction } from "../../../dataProvider";

const useStyles = makeStyles(() => ({
  fileUpload: {
    width: "100%",
  },
  link: {
    marginBottom: "10px",
    cursor: "pointer",
  },
  fetchPrice: {
    marginTop: "20px",
  },
  warnLabel: {
    fontSize: "12px",
    color: "red",
    display: "block",
  },
}));

const FileUpload = (props) => {
  const notify = useNotify();
  const form = useForm();
  const isDisabled = Object.keys(form.getState().values).length === 0;

  const handleUpload = async () => {
    const file = { file: form.getState().values.files };
    if (typeof file === "undefined" || !file.file || file.file.length === 0) {
      notify("Please select a file to upload");
      return;
    }

    const formData = await rawFileExtraction(file);
    props.uploadFile(formData).then(() => {
      form.change("files", []);
    });
  };

  return (
    <Button
      variant="outlined"
      disabled={isDisabled}
      onClick={handleUpload}
      fullWidth
    >
      Upload
    </Button>
  );
};

export default () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const notify = useNotify();
  const refresh = useRefresh();

  const uploadFile = async (file) => {
    setLoading(true);
    dispatch(fetchStart());

    let axiosConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    };
    await axios
      .post(`${apiUrl}/netsuite/ring-finish-import`, file, axiosConfig)
      .then((response) => {
        notify(response.data.message);
        refresh();
        return {
          data: {
            ...response.data,
          },
        };
      })
      .catch(
        ({
          response: {
            data: { errors },
          },
        }) => {
          const message = errors[Object.keys(errors)[0]][0];
          notify(message, "warning");
        }
      )
      .finally(() => {
        setLoading(false);
        dispatch(fetchEnd());
      });
  };

  const downloadExport = () => {
    axios.get(`${apiUrl}/netsuite/ring-finish-export`).then((response) => {
      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      const date = new Date();
      link.setAttribute(
        "download",
        `ring_finish_export_${date.toLocaleString()}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const handleFileReject = () =>
    notify("Please upload the correct file format");
  return (
    <Card>
      <CardContent>
        <Grid container xs={12} justify="space-between" alignItems="center">
          <Grid item xs={5}>
            <SimpleForm toolbar={null}>
              <Grid
                item
                container
                justify="center"
                className={classes.fileUpload}
              >
                <Grid item xs={12}>
                  <FileInput
                    source="files"
                    label="Upload Ring Finish Netsuite IDs"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    multiple={false}
                    options={{ onDropRejected: handleFileReject }}
                    placeholder={
                      <p>
                        Drop a file to upload, or click to select it.
                        <span className={classes.warnLabel}>
                          *File format must be .csv
                        </span>
                      </p>
                    }
                  >
                    <FileField source="src" title="title" />
                  </FileInput>
                </Grid>
              </Grid>
              <FileUpload uploadFile={uploadFile} />
            </SimpleForm>
          </Grid>
          <Grid
            container
            item
            xs={5}
            direction="column"
            justify="space-between"
          >
            <Button variant="outlined" onClick={downloadExport}>
              Export Ring Finish Netsuite IDs
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
